import React from "react";
import GridService from "../GridService";
import PuzzleCardBase from "../../common/components/PuzzleCardBase";
import {
    getGridProgress,
    getGridPlayData,
    getGridWordCount,
    getGridNavigationPath,
    getGridCardContentPadding
} from "../../common/utils/PuzzleCardHelpers";

const GridCard = ({
    puzzle,
    userPayPlan,
    subscriptionStatus,
    onPlayClick,
    buttonText = "Play",
    isInProgress = false,
    forceUnlock = false,
    hideWordCountChip = false,
    belowDifficultySlot = null,
    browseStoriesChrome = false,
    hideClusteredBubbles = false,
    primaryActionReplacement = null,
    hideFreeTierBadge = false,
    actionButtonSx = null,
}) => {
    return (
        <PuzzleCardBase
            puzzle={puzzle}
            userPayPlan={userPayPlan}
            subscriptionStatus={subscriptionStatus}
            onPlayClick={onPlayClick}
            buttonText={buttonText}
            isInProgress={isInProgress}
            forceUnlock={forceUnlock}
            service={GridService}
            getProgress={getGridProgress}
            getPlayData={getGridPlayData}
            getWordCount={getGridWordCount}
            getNavigationPath={getGridNavigationPath}
            getCardContentPadding={getGridCardContentPadding}
            hideWordCountChip={hideWordCountChip}
            belowDifficultySlot={belowDifficultySlot}
            browseStoriesChrome={browseStoriesChrome}
            hideClusteredBubbles={hideClusteredBubbles}
            primaryActionReplacement={primaryActionReplacement}
            hideFreeTierBadge={hideFreeTierBadge}
            actionButtonSx={actionButtonSx}
        />
    );
};

export default GridCard;
